<template>
  <div>
    <!-- :get-form-data="fromData" -->
    <list
      row-key="index"
      ref="list"
      unit="批量台账"
      :page="page"
      :show-query="true"
      :get-data-func="api.batchNumberStRunningAccountRpt"
      v-if="trendShow"
      :queryParamsAppend="params"
      urlHash="business/stock/batchinventoryledger"
      :resetDataFunc="resetDataFunc"
    >
      <template slot="toolbar-right">
        <slot name="toolbar-right"></slot>
        <el-button type="primary" @click="onExport" >导出</el-button>
      </template>
      <template slot="query">
        <el-form-item label="存货">    
          <select-input  
            placeholder="存货"
            :label="ProductName"
            v-model="params.ProductId"
            @click="openProduct"
            style="width: 180px"
          />
        </el-form-item>
      </template>
      <template slot="table">
        <slot name="column"></slot>
      </template>
    </list>
    <list-dialog ref="listDialog" in-dialog selectable @select="setProduct" />
  </div>
</template>
<script>  

  
import listMixin from "@/mixins/trend/list";
import list from "@/components/common/trendsTable/list";
import listDialog from '@/components/basedata/inventory/archives/listDialog'

export default {
  mixins: [listMixin],
  components: { list,listDialog  },
  data() {
    return {
      api: require('@/api/stock/stReport').default,
      trendShow: true,
      tableData: [],
      ProductName: "",
      params: {
        ProductId: 0,
        StartTime:"",
        EndTime:""
      }
    };
  },
   mounted(){
     ;
  },
  methods: {

    onExport() {
      this.$confirm("是否导出数据？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          var list = this.$refs.list;
          var listParams = list.tempQueryParams;
          var fields = list.tableList.map(x => x.tableName);
          var params = { ...listParams, Fields: fields.join(',') };
          // console.log('onExport', params);
          var loading = this.$loading({
            lock: true,
            text: "正在导出...",
            spinner: "el-icon-loading",
            customClass: "my_loading",
            background: "rgba(0, 0, 0, 0.3)",
          });
          this.api.batchNumberStRunningAccountRptExport(params).then(res => {
            loading.close();
          })
        })
        .catch(() => {});
      
    },
    resetDataFunc(data){
      data.forEach(item => {
        if(item.Type){
          item.Type = '发出'
        }else{
          item.Type = '收入'
        }
        item.BalancePrice=Number(item.BalancePrice||0).toFixed(2)
        item.OutPrice=Number(item.OutPrice||0).toFixed(2)
        item.InPrice=Number(item.InPrice||0).toFixed(2)
      })
      console.log('======data=========', data)
      return data
    },
    openProduct(){
      this.$refs.listDialog.open()
    },
    setProduct(data){
      this.ProductName = data.ProductName;
      this.params.ProductId = data.ProductId
    }
  }
};
</script>
